import React from 'react';
import styled from 'styled-components';

import FieldContextFeeder from '../components/FieldContextFeeder';

import { Linkset } from '~ui-kit';

const LinksetField = props => {
  const name = props.id || props.name;

  const localProps = {
    ...props,
  };

  return (
    <Container>
      <Linkset name={name} {...localProps} />
    </Container>
  );
};

const Container = styled.div`
  max-width: var(--field-width);
`;

export default FieldContextFeeder(LinksetField);
